export default __webpack_public_path__ + "static/media/w4.425d2455.png";